import axios from 'axios'

const HTTPInit = axios.create({
  baseURL: process.env.SHAPPY_API_URL
})

HTTPInit.defaults.headers.post['Content-Type'] = 'application/json'

HTTPInit.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    // window.location = process.env.LOGIN_URL
  } else {
    return Promise.reject(error)
  }
})

export const HTTP = HTTPInit



// WEBPACK FOOTER //
// ./src/api/http-shappy-common.js